(function ($) {
  const nameOfPoliticyButton = $('.cookies__button:last-child').text()
  function mediaSize() {
    if (window.matchMedia("(max-width: 900px)").matches) {
      if ($(".nav__exit").length < 1) {
        const exit = $(
          '<li class="nav__exit"><span class="nav__exit-text">menu</span><button class="nav__exit-icon"></button></li>'
        );
        exit.prependTo(".nav__list");
      }

      $(".nav__exit").click(function (e) {
        e.preventDefault();
        $(".nav--mobile").removeClass("nav--mobile--active");
        $("body").removeClass("dark");
      });

      $(".hamburger").click(() => {
        $("body").addClass("dark");
        $(".nav--mobile").addClass("nav--mobile--active");
      });
      AOS.refresh();
      $("body").css(
        "padding-top",
        `${$(".header--mobile").outerHeight(true)}px`
      );
      $('.cookies__button:last-child').text('Więcej informacji')
      $('.blogBigger__grid .blogBigger__single:first-child').height($(window).height() - $('.header--mobile').height())
    } else {
      $("body").css("padding-top", `0px`);
      $(".footer__single-arrow").remove();
      $(".nav__list").removeClass("nav__list--active");
      $(".nav__exit").remove();
      $('.cookies__button:last-child').text(nameOfPoliticyButton)
      $('.blogBigger__grid .blogBigger__single:first-child').height($(window).height())
      AOS.refresh();
    }

    if (window.matchMedia("(max-width: 700px)").matches) {
      $(".footer__single .menu").hide();
      $(".footer__single").each(function () {
        if ($(this).find(".menu").length > 0) {
          if ($(this).find(".footer__single-arrow").length > 0) {
            return;
          } else {
            $('<span class="footer__single-arrow"></span>').appendTo(
              $(this).find(".footer__single-title")
            );
            $(this)
              .find(".footer__single-title")
              .click(function (e) {
                e.preventDefault();
                $(this).siblings("div").find(".menu").slideToggle();
                $(this).toggleClass("footer__single--active-title");
              });
          }
        } else return;
      });
    } else {
      $(".footer__single .menu").show();
      $(".footer__single-arrow").remove();
    }
  }

  mediaSize();
  window.addEventListener("resize", mediaSize, false);
})(jQuery);
